const operatorMap = {
    '+': (a: number, b: number) => a + b,
    '-': (a: number, b: number) => a - b
};

export const calculate = (parts: (number | '+' | '-')[]): number => {
    let result: number | null = null;
    let operator: ((a: number, b: number) => number) | null = null;

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (part === '+' || part === '-') {
            operator = operatorMap[part];
            continue;
        }

        if (result === null && !operator) {
            result = part; // initiate with first part.
            continue;
        }

        if (operator) {
            result = operator(result || 0, part);

            operator = null;
        }
    }

    return result || 0;
};
